<table>
  <thead>
    <tr>
      <th *ngFor="let key of question.settings.table_columns_order">{{ getLabel(key) }}</th>
      <th class="action"></th>
      <th class="action"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of question.data; index as i;" [ngClass]="{ 'hasError': !isRepeaterValid(question.key, i) }">
      <td *ngFor="let key of question.settings.table_columns_order">{{ formatValue(key, row, i) }}</td>
      <td class="action">
        <button mat-icon-button color="primary" type="button" (click)="edit(i)" [disabled]="editing">
          <mat-icon class="create_outline material-icons-outlined"></mat-icon>
        </button>
      </td>
      <td class="action">
        <button mat-icon-button color="primary" type="button" (click)="delete(i)" [disabled]="editing">
          <mat-icon class="delete material-icons-outlined"></mat-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
